export default "__VITE_ASSET__CYURsoDk__"